import { isEmpty } from "lodash";
import { arrayToObj } from "../../Libs/CustomMethods/customMethods";

import {
  REOPEN_CONVERSATION_POST,
  REOPEN_CONVERSATION_RES,
} from "./actionTypes";

const initialState = {
  data: {},
  loading: false,
  success: false,
  error: false,
};

const dataReducer = (state = initialState, action) => {
  switch (action.type) {
    case REOPEN_CONVERSATION_POST:
      state = {
        ...state,
        loading: true,
        success: false,
        error: false,
      };
      break;
    case REOPEN_CONVERSATION_RES: {
      switch (action.payload.action) {
        case "reopenGet": {
          const objData = action.payload.data.data;
          const id = Object.keys(objData)?.[0];
          const data = Object.values(objData)?.[0];
          const newData = {
            ...state.data,
            [id]: {
              ...state.data?.[id],
              ...data,
            },
          };
          state = { ...state, ...action.payload.data, data: newData };
          break;
        }
        case "reopenPost": {
          const newData = { ...state.data, ...action.payload.data.data };
          state = { ...state, ...action.payload.data, data: newData };
          break;
        }
        case "api": {
          const data = action.payload.data.data;
          const reopenArray = data
            .filter((e) => !isEmpty(e.reopen))
            .map((e) => e.reopen);
          const reopenObj = arrayToObj(reopenArray, "conversationId");
          const newData = { ...state.data, ...reopenObj };
          state = { ...state, ...action.payload.data, data: newData };
          break;
        }
        default:
          state = { ...state, ...action.payload.data };
          break;
      }

      break;
    }
    default:
      break;
  }
  return state;
};

export default dataReducer;
